export const FETCH_SAIL_PACKAGES = 'routes/sailPackages/FETCH_SAIL_PACKAGES'
export const FETCH_SAIL_PACKAGES_SUCCESS = 'routes/sailPackages/FETCH_SAIL_PACKAGES_SUCCESS'
export const FETCH_SAIL_PACKAGES_ERROR = 'routes/sailPackages/FETCH_SAIL_PACKAGES_ERROR'
export const SET_SAIL_PACKAGES_STATE = 'routes/sailPackages/SET_SAIL_PACKAGES_STATE'
export const MANAGE_SAIL_PACKAGES_FETCH_RESPONSE = 'routes/sailPackages/MANAGE_SAIL_PACKAGES_FETCH_RESPONSE'
